import { render, staticRenderFns } from "./UserTypeAutocomplete.vue?vue&type=template&id=22b7e4a4"
import script from "./UserTypeAutocomplete.vue?vue&type=script&lang=js"
export * from "./UserTypeAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports